import { Button, Tab, Tabs } from "react-bootstrap";
import { Modal } from "../../../components";
import { useActasStore } from "../../../store/actasStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import FormMarcarImpresa from "../../Forms/ActaAImprimir";
import useActas from "../../../api/actas";

const ModalMarcarImpresa = ({ type }) => {
  const { modals, handlerModal } = useGeneralAppStore();
  const { setActaDetalle, actaAImprimir } = useActasStore()
  const { marcarActaImpresa } = useActas();

  return (
    <>
      <Modal
        show={modals.includes("marcar_impresa")}
        size={"md"}
        onHide={() => handlerModal({ modal: false, modalName: "marcar_impresa" })}
        title={() => `Marcar acta ${actaAImprimir?.dependencia}-${actaAImprimir?.numero_acta} como impresa`}
      >
        <>
          {actaAImprimir?.fecha_impresion ? null : (
            <>
              {
                type == "table" &&
                <Button
                  size="lg"
                  className="w-100"
                  onClick={() =>
                    marcarActaImpresa({
                      id_acta: actaAImprimir?.id,
                      fecha_impresion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000)
                        .toISOString()
                        .slice(0, 19),
                    })
                  }
                >
                  Marcar acta como impresa
                </Button>
              }
              {
                type == "detalle" &&
                <FormMarcarImpresa acta={actaAImprimir} />
              }


            </>
          )}
        </>
      </Modal>
    </>
  );
}
export default ModalMarcarImpresa;